/*!
 * cardcosmos Geschenkefinder 4.0 – Oberfläche
 * Lädt cc-giftfinder-engine.js (window.CCGiftEngine) erst bei Bedarf nach – die Startseite bleibt schlank.
 * Keine externen Abhängigkeiten.
 */
(function () {
  'use strict';
  var W = window, D = document;
  var E = W.CCGiftEngine || null, engineLoading = null;
  function loadEngine(url) {
    if (E) return Promise.resolve(E);
    if (!engineLoading) engineLoading = new Promise(function (res, rej) {
      var sc = D.createElement('script'); sc.src = url; sc.async = true;
      sc.onload = function () { E = W.CCGiftEngine || null; if (E) res(E); else { engineLoading = null; rej(new Error('engine_missing')); } };
      sc.onerror = function () { engineLoading = null; sc.remove(); rej(new Error('engine_load')); };
      D.head.appendChild(sc);
    });
    return engineLoading;
  }
  if (W.CCGiftFinder && W.CCGiftFinder.scan) { W.CCGiftFinder.scan(D); return; }

  /* ---------------------------------------------------------------- *
   * Fragen und Antworten (Texte zentral hier pflegen)
   * ---------------------------------------------------------------- */
  var Q = {
    knowledge: { title: 'Wie gut kennst du dich mit dem Hobby der Person aus?', hint: 'Danach richten wir die weiteren Fragen und Erklärungen aus.' },
    age: { title: 'Für wen suchst du ein Geschenk?', hint: 'Wir achten auf hinterlegte Altersangaben der Produkte.' },
    game: { title: 'Welche Karten mag die Person?', hint: 'Wenn du es nicht weißt, finden wir trotzdem etwas Passendes.' },
    otherGame: { title: 'Welches Kartenspiel ist es?', hint: 'Hier stehen alle weiteren Spiele aus unserem Sortiment.' },
    activity: { title: 'Was macht die Person am liebsten mit ihren Karten?', hint: 'Wähle, was am ehesten passt.' },
    unboxSize: { title: 'Wie groß soll das Geschenk ungefähr sein?', hint: 'Alle Varianten enthalten Booster zum Auspacken.' },
    collectStyle: { title: 'Wie sammelt die Person?', hint: 'So erkennen wir, ob neue Produkte oder Zubehör besser passen.' },
    playLevel: { title: 'Wie erfahren ist die Person beim Spielen?', hint: 'Davon hängt ab, ob ein Starter oder ein fertiges Deck besser passt.' },
    protectNeed: { title: 'Was wäre besonders praktisch?', hint: 'Zubehör für Karten, die die Person schon besitzt.' },
    rareKnowledge: { title: 'Kennst du einen Lieblingscharakter oder eine bestimmte Karte?', hint: 'Einzelkarten schlagen wir nur bei einem konkreten Wunsch vor.' },
    language: { title: 'In welcher Sprache dürfen die Karten sein?', hint: 'Sammelkarten gibt es in mehreren Sprachen. Zubehör ist davon nicht betroffen.' },
    budget: { title: 'Wie viel möchtest du höchstens ausgeben?', hint: 'Die Grenze gilt verbindlich für den Preis der empfohlenen Ausführung.' }
  };
  var O = {
    knowledge: [
      ['none', 'Gar nicht', 'Ich möchte einfach ein schönes Geschenk finden.'],
      ['some', 'Ein bisschen', 'Ich weiß ungefähr, welche Karten die Person mag.'],
      ['expert', 'Ziemlich gut', 'Ich kenne das Kartenspiel und weiß, welche Produkte interessant sind.']
    ],
    age: [
      ['u6', 'Kind unter 6 Jahren', ''], ['a6', 'Kind von 6 bis 9 Jahren', ''], ['a10', 'Kind von 10 bis 13 Jahren', ''],
      ['teen', 'Teenager von 14 bis 17 Jahren', ''], ['adult', 'Erwachsene Person', ''], ['unknown', 'Ich weiß es nicht genau', '']
    ],
    game: [
      ['pokemon', 'Pokémon', ''], ['magic', 'Magic: The Gathering', ''], ['onepiece', 'One Piece', ''],
      ['lorcana', 'Disney Lorcana', ''], ['yugioh', 'Yu-Gi-Oh!', ''], ['riftbound', 'Riftbound', 'League of Legends'],
      ['other', 'Andere Kartenspiele', 'Zum Beispiel Star Wars: Unlimited oder Dragon Ball.'],
      ['unknown', 'Ich weiß es leider nicht', 'Dann zeigen wir Geschenke, die zu jeder Sammlung passen.']
    ],
    activity: [
      ['unbox', 'Neue Karten auspacken', 'Die Person freut sich über neue Karten und die Überraschung beim Öffnen.'],
      ['collect', 'Karten sammeln', 'Die Person möchte ihre Sammlung erweitern und besondere Karten entdecken.'],
      ['play', 'Mit Karten spielen', 'Die Person spielt das Kartenspiel oder baut eigene Decks.'],
      ['protect', 'Karten aufbewahren und schützen', 'Die Person besitzt bereits Karten und möchte sie sicher aufbewahren.'],
      ['rare', 'Besondere Sammlerstücke', 'Die Person interessiert sich für besondere Karten oder hochwertige Sammlerprodukte.'],
      ['unknown', 'Ich weiß es nicht', 'Wir helfen dir, eine möglichst sichere Geschenkidee zu finden.']
    ],
    unboxSize: [
      ['few', 'Ein paar Boosterpäckchen', 'Booster sind Päckchen mit zufällig zusammengestellten Karten.'],
      ['box', 'Eine schöne Geschenkbox', 'Zum Beispiel eine Kollektion oder Top-Trainer-Box mit festem Inhalt.'],
      ['big', 'Eine große Boosterbox (Display)', 'Ein Display ist eine größere Box mit vielen Boosterpäckchen.'],
      ['open', 'Ich bin offen für Empfehlungen', 'Wir wählen das Format passend zum Budget.']
    ],
    collectStyle: [
      ['sealed', 'Sie öffnet gern neue Produkte', 'Booster, Boxen und Kollektionen.'],
      ['set', 'Sie sammelt ein bestimmtes Set', 'Du kannst den Namen gleich eingeben.'],
      ['show', 'Sie zeigt ihre Sammlung gern', 'Zum Beispiel in einem Sammelalbum oder einem Kartenhalter.'],
      ['open', 'Weiß ich nicht', 'Wir mischen verschiedene Sammelgeschenke.']
    ],
    playLevel: [
      ['learn', 'Möchte das Spiel kennenlernen', 'Starterprodukte erklären die Regeln und sind sofort spielbar.'],
      ['casual', 'Spielt gelegentlich', 'Fertige Decks und praktisches Spielzubehör.'],
      ['regular', 'Spielt regelmäßig', 'Zum Beispiel Commander-Decks oder hochwertiges Zubehör.'],
      ['open', 'Weiß ich nicht', 'Wir schlagen Produkte vor, die für viele passen.']
    ],
    protectNeed: [
      ['album', 'Ein schönes Sammelalbum', 'Karten geordnet in Fächern aufbewahren.'],
      ['single', 'Schutz für einzelne Karten', 'Toploader, Magnethalter oder Kartenhüllen.'],
      ['storage', 'Eine Aufbewahrungsbox', 'Für größere Kartenmengen oder ungeöffnete Boxen.'],
      ['premium', 'Etwas besonders Hochwertiges', 'Hochwertige Alben und Präsentationsstücke.'],
      ['open', 'Ich weiß es nicht', 'Wir zeigen die beliebtesten Möglichkeiten.']
    ],
    rareKnowledge: [
      ['known', 'Ja, ich kenne den Namen', 'Zum Beispiel ein Lieblings-Pokémon oder eine Figur.'],
      ['set', 'Ich weiß ungefähr, was gesammelt wird', 'Zum Beispiel ein Set oder eine Erweiterung.'],
      ['open', 'Nein', 'Dann schlagen wir besondere Produkte vor, aber keine zufällige Einzelkarte.']
    ],
    language: [
      ['de', 'Nur Deutsch', 'Die sichere Wahl, wenn du unsicher bist.'],
      ['de_en', 'Deutsch oder Englisch', ''],
      ['plus_ja', 'Auch Japanisch', 'Deutsch, Englisch und Japanisch.'],
      ['plus_zh', 'Auch Chinesisch', 'Deutsch, Englisch und Chinesisch.'],
      ['intl', 'Andere internationale Ausgaben sind ebenfalls in Ordnung', 'Zum Beispiel auch Koreanisch.'],
      ['any', 'Die Sprache ist egal', '']
    ],
    budget: [
      [2000, 'Bis 20 €', ''], [4000, 'Bis 40 €', ''], [7500, 'Bis 75 €', ''], [15000, 'Bis 150 €', ''],
      [30000, 'Bis 300 €', ''], ['over300', 'Mehr als 300 €', ''], ['custom', 'Eigenen Betrag eingeben', '']
    ]
  };
  var IMAGE_STEPS = { game: 1, activity: 1, unboxSize: 1, protectNeed: 1, playLevel: 0, collectStyle: 1, otherGame: 0 };
  /* Schritte, deren Bilder dem gewählten Spiel folgen (Magic gewählt → Magic-Produkte, nie Pokémon) */
  var GAME_STEPS = { activity: 1, unboxSize: 1, collectStyle: 1, playLevel: 1, rareKnowledge: 1 };
  /* Bildquelle je Antwort: Produktfamilien in Wunschreihenfolge. own = cardcosmos bevorzugen, neutral = spielneutral */
  var STEP_VISUALS = {
    activity: { unbox: { fam: ['display', 'bundle', 'booster'] }, collect: { fam: ['etb', 'collection', 'chest', 'tin', 'giftset'] },
      play: { fam: ['starter', 'precon'] }, protect: { fam: ['binder', 'storage', 'magnetic'], own: true, neutral: true }, rare: { fam: ['graded', 'special', 'chest', 'trove', 'display'] } },
    unboxSize: { few: { fam: ['booster', 'blister', 'tin'] }, box: { fam: ['etb', 'collection', 'giftset', 'chest', 'trove'] }, big: { fam: ['display'] } },
    collectStyle: { sealed: { fam: ['etb', 'collection', 'display'] }, set: { fam: ['display', 'collection', 'etb'] }, show: { fam: ['binder', 'presentation', 'magnetic'], own: true, neutral: true } },
    protectNeed: { album: { fam: ['binder'], own: true, neutral: true }, single: { fam: ['magnetic', 'toploader'], own: true, neutral: true },
      storage: { fam: ['storage', 'acrylic'], own: true, neutral: true }, premium: { fam: ['binder', 'presentation'], own: true, premium: true, neutral: true } }
  };
  function visualWant(step, value, game) {
    if (value === 'unknown' || value === 'open') return null;
    var cfg = E.CONFIG.games, w;
    if (step === 'game') {
      w = value === 'other' ? { games: Object.keys(cfg).filter(function (g) { return !cfg[g].main && g !== 'family'; }) } : { games: [value] };
      w.fam = ['display', 'etb', 'collection', 'bundle', 'starter'];
    } else if (step === 'otherGame') w = { games: [value], fam: ['display', 'starter', 'precon', 'collection', 'bundle', 'booster'] };
    else w = STEP_VISUALS[step] && STEP_VISUALS[step][value] ? Object.assign({}, STEP_VISUALS[step][value]) : null;
    if (!w) return null;
    if (!w.games && !w.neutral && game) w.games = [game];
    return w;
  }
  function jitter(id, seed) { var h = 2166136261, s = String(id) + seed; for (var i = 0; i < s.length; i++) { h ^= s.charCodeAt(i); h = Math.imul(h, 16777619); } return ((h >>> 0) % 1000) / 1000; }
  var FULL_STEPS = { activity: 1, unboxSize: 1, collectStyle: 1, playLevel: 1, protectNeed: 1, rareKnowledge: 1, language: 1, knowledge: 1 };
  var DEPTH_KEYS = ['unboxSize', 'collectStyle', 'playLevel', 'protectNeed', 'rareKnowledge'];

  function fresh() {
    return { knowledge: null, age: null, game: null, otherGame: null, activity: null, unboxSize: null, collectStyle: null,
      playLevel: null, protectNeed: null, rareKnowledge: null, favoriteTerm: '', setTerm: '', language: null, budget: null, budgetChoice: null };
  }
  function el(tag, cls, txt) { var x = D.createElement(tag); if (cls) x.className = cls; if (txt !== undefined && txt !== null) x.textContent = String(txt); return x; }
  function safeUrl(u, sameOrigin) {
    try { var x = new URL(u, W.location.href); if (x.protocol !== 'https:' && x.protocol !== 'http:') return null; if (sameOrigin && x.origin !== W.location.origin) return null; return x.href; } catch (e) { return null; }
  }
  function parseMoney(v) {
    var s = String(v == null ? '' : v).replace(/[\s €]/g, '').replace(/eur/i, '');
    if (/^\d{1,3}(\.\d{3})+(,\d{1,2})?$/.test(s)) s = s.replace(/\./g, '');
    if (!/^\d+([.,]\d{1,2})?$/.test(s)) return null;
    var c = Math.round(parseFloat(s.replace(',', '.')) * 100);
    return c > 0 && c <= 100000000 ? c : null;
  }
  function reduced() { return W.matchMedia && W.matchMedia('(prefers-reduced-motion: reduce)').matches; }

  /* ---------------------------------------------------------------- */
  function Finder(root) {
    this.root = root;
    this.cfg = JSON.parse(root.querySelector('[data-ccgf-config]').textContent);
    this.stage = root.querySelector('[data-ccgf-stage]');
    this.intro = root.querySelector('[data-ccgf-intro]');
    this.live = root.querySelector('[data-ccgf-live]');
    this.uid = 'ccgf' + Math.random().toString(36).slice(2, 8);
    this.a = fresh(); this.rows = null; this.meta = null; this.loading = null; this.seq = 0; this.dead = false;
    this.controllers = []; this.loadInfo = {};
    this.money = new Intl.NumberFormat('de-DE', { style: 'currency', currency: this.cfg.currency || 'EUR' });
    this.debug = !!(this.cfg.designMode && (this.cfg.debug || /[?&]ccgf_debug=1/.test(W.location.search)));
    var self = this;
    var start = root.querySelector('[data-ccgf-start]');
    this.seed = Math.random().toString(36).slice(2, 6); this.shownVisuals = {}; this.visualCache = {};
    if (start) { start.disabled = false; start.addEventListener('click', function () { self.begin(); }); }
    this.warmup(start);
    this.onPop = function (ev) { var st = ev.state; if (st && st.ccgf === self.uid) { if (st.step === '_results') self.results(true); else if (st.step) self.view(st.step, true, true); } else if (self.root.classList.contains('ccgf--running')) { self.restart(true, true); } };
    W.addEventListener('popstate', this.onPop);
    root.classList.add('ccgf--ready');
    if (this.cfg.preview && this.cfg.autostart) this.begin();
  }

  Finder.prototype.track = function (name, data) {
    var payload = Object.assign({ version: '4.0.0' }, data || {});
    try { this.root.dispatchEvent(new CustomEvent('ccgf:event', { bubbles: true, detail: { name: name, data: payload } })); } catch (e) {}
    if (!this.cfg.analytics) return;
    try {
      var cp = W.Shopify && W.Shopify.customerPrivacy;
      var allowed = cp && typeof cp.analyticsProcessingAllowed === 'function' ? cp.analyticsProcessingAllowed() : false;
      if (allowed && W.Shopify.analytics && typeof W.Shopify.analytics.publish === 'function') W.Shopify.analytics.publish(name, payload);
    } catch (e) {}
  };
  /* Vorladen ohne Einfluss auf PageSpeed: Engine und Sortiment erst bei der ersten echten Interaktion
     (Scrollen, Tippen, Zeigen auf den Button) – nie automatisch beim Seitenaufruf. Datensparmodus wird respektiert. */
  Finder.prototype.warmup = function (start) {
    var self = this, done = false, conn = W.navigator && W.navigator.connection;
    if (conn && (conn.saveData || /(^|-)2g$/.test(conn.effectiveType || ''))) return;
    var events = ['scroll', 'pointerdown', 'keydown', 'touchstart'];
    function go() {
      if (done) return; done = true;
      events.forEach(function (t) { W.removeEventListener(t, go, true); });
      self.catalog().catch(function () {});
    }
    this.unwarm = function () { done = true; events.forEach(function (t) { W.removeEventListener(t, go, true); }); };
    events.forEach(function (t) { W.addEventListener(t, go, { capture: true, passive: true }); });
    if (start) ['pointerenter', 'focus'].forEach(function (t) { start.addEventListener(t, go, { once: true, passive: true }); });
  };
  Finder.prototype.engine = function () { return loadEngine(this.cfg.engineUrl); };
  Finder.prototype.say = function (t) { this.live.textContent = ''; var l = this.live; setTimeout(function () { l.textContent = t; }, 30); };

  Finder.prototype.begin = function () {
    var self = this;
    this.root.classList.add('ccgf--running');
    if (this.intro) this.intro.hidden = true;
    this.track('giftfinder_started', {});
    this.catalog().catch(function () {});
    this.engine().then(function () { if (!self.dead) self.view('knowledge'); }, function () {
      self.stage.textContent = 'Der Geschenkefinder kann gerade nicht geöffnet werden. Bitte lade die Seite neu.';
    });
  };

  /* ------------------------- Katalog laden ------------------------- */
  Finder.prototype.cacheKey = function () {
    return 'ccgf4:' + [this.cfg.collectionHandle, this.cfg.currency, this.cfg.country, this.cfg.useAvailabilityFilter ? 'a' : 'f'].join(':');
  };
  Finder.prototype.request = function (url, type) {
    var ac = typeof AbortController === 'function' ? new AbortController() : null, self = this;
    if (ac) this.controllers.push(ac);
    var tries = 0;
    function go() {
      tries++;
      return fetch(url, { credentials: 'same-origin', headers: { Accept: type === 'json' ? 'application/json' : 'text/html' }, signal: ac ? ac.signal : undefined })
        .then(function (r) {
          if (r.status === 429 && tries < 3) return new Promise(function (res) { setTimeout(res, 800 * tries); }).then(go);
          if (!r.ok) throw new Error('http_' + r.status);
          return type === 'json' ? r.json() : r.text();
        });
    }
    return go().finally(function () { if (ac) self.controllers = self.controllers.filter(function (x) { return x !== ac; }); });
  };
  Finder.prototype.pageUrl = function (page) {
    var u = new URL(this.cfg.collectionUrl, W.location.origin);
    u.searchParams.set('section_id', this.cfg.dataSection);
    u.searchParams.set('page', String(page));
    u.searchParams.set('sort_by', 'created-ascending');
    if (this.cfg.useAvailabilityFilter) u.searchParams.set('filter.v.availability', '1');
    var pv = new URLSearchParams(W.location.search).get('preview_theme_id');
    if (pv && /^\d+$/.test(pv)) u.searchParams.set('preview_theme_id', pv);
    return u.href;
  };
  Finder.prototype.loadPage = function (page) {
    var self = this;
    if (this.cfg.preview && W.CCGF_PREVIEW_PAGES) return Promise.resolve(W.CCGF_PREVIEW_PAGES(page, this.cfg));
    return this.request(this.pageUrl(page), 'text').then(function (html) {
      // JSON direkt aus dem Text schneiden – deutlich schneller als das ganze HTML per DOMParser aufzubauen
      var at = html.indexOf('data-ccgf-feed'); if (at < 0) throw new Error('feed_missing');
      var a = html.indexOf('>', at) + 1, b = html.indexOf('</script>', a); if (!a || b < 0) throw new Error('feed_missing');
      var data = JSON.parse(html.slice(a, b));
      if (!data.meta || data.meta.ok !== true) throw new Error('feed_not_ok');
      if (data.meta.currency && self.cfg.currency && data.meta.currency !== self.cfg.currency) throw new Error('currency_mismatch');
      return data;
    });
  };
  /* Sortiment im Tab zwischenspeichern: Preis und Bestand der angezeigten Produkte werden ohnehin live geprüft */
  var CACHE_MS = 10 * 60 * 1000;
  Finder.prototype.catalog = function () {
    var self = this;
    if (this.rows) return Promise.resolve(this.rows);
    if (this.loading) return this.loading;
    if (!E) return this.engine().then(function () { return self.catalog(); });
    if (!this.cfg.preview) {
      try {
        var hit = JSON.parse(W.sessionStorage.getItem(this.cacheKey()) || 'null');
        if (hit && Date.now() - hit.at < CACHE_MS && Array.isArray(hit.rows) && hit.meta) {
          this.rows = hit.rows; this.meta = hit.meta; this.loadInfo = hit.info || {}; this.loadInfo.cached = true;
          return Promise.resolve(this.rows);
        }
      } catch (e) {}
    }
    var t0 = Date.now(), attempt = 0, pagesKey = this.cacheKey() + ':pages', guess = 1;
    try { guess = parseInt(W.localStorage.getItem(pagesKey), 10) || 1; } catch (e) {}
    this.catalogFailed = false; this.root.classList.add('ccgf--pending');
    function run() {
      attempt++;
      // Seitenzahl vom letzten Besuch: alle Seiten gleichzeitig anfragen statt erst Seite 1 abzuwarten
      return E.collectCatalog(function (n) { return self.loadPage(n); }, function (done, total) {
        self.progress = [done, total];
        var p = self.stage.querySelector('[data-ccgf-progress]');
        if (p) p.textContent = done.toLocaleString('de-DE') + ' von ' + total.toLocaleString('de-DE') + ' Produkten geprüft';
      }, { concurrency: 6, maxPages: 100, guessPages: Math.min(guess, 12) }).catch(function (err) {
        if (attempt < 2 && /changed|mismatch|duplicates|incomplete/.test(String(err && err.message))) return run();
        throw err;
      });
    }
    this.loading = run().then(function (res) {
      var filters = res.meta.filters || [];
      var av = filters.filter(function (f) { return f.p === 'filter.v.availability'; })[0];
      self.loadInfo = {
        ms: Date.now() - t0, pages: res.meta.pages, total: res.meta.total, attempts: attempt,
        availabilityFilter: !!(av && av.a && av.a.indexOf('1') >= 0) ? 'aktiv' : (self.cfg.useAvailabilityFilter ? 'nicht verfügbar – gesamter Katalog geladen' : 'aus')
      };
      self.rows = res.rows; self.meta = res.meta;
      try { W.localStorage.setItem(pagesKey, String(res.meta.pages)); } catch (e) {}
      if (!self.cfg.preview) { try { W.sessionStorage.setItem(self.cacheKey(), JSON.stringify({ at: Date.now(), rows: res.rows, meta: res.meta, info: self.loadInfo })); } catch (e) {} }
      self.root.classList.remove('ccgf--pending');
      self.refreshVisuals();
      return self.rows;
    }).catch(function (err) {
      self.catalogFailed = true; self.root.classList.remove('ccgf--pending');
      self.refreshVisuals(); // dann greifen die im Theme-Editor gepflegten Antwortbilder
      throw err;
    }).finally(function () { self.loading = null; });
    return this.loading;
  };

  /* ------------------------- Bilder ------------------------- */
  Finder.prototype.gameKey = function () {
    var g = this.a.game === 'other' ? this.a.otherGame : this.a.game;
    return g && g !== 'unknown' && g !== 'other' ? g : null;
  };
  /* Bilder kommen automatisch aus dem Sortiment (nur Produkte mit echtem Lagerbestand). Gepflegte Antwortbilder
     sind Ersatz, falls das Sortiment nicht lädt – und Logos haben immer Vorrang. Bei bekanntem Spiel zeigen
     Folgeschritte nie ein Bild eines anderen Spiels. */
  Finder.prototype.visualFor = function (step, value) {
    var conf = this.cfg.visuals && this.cfg.visuals[step + ':' + value];
    if (conf && conf.src && conf.logo) return conf;
    if (this.rows) { var auto = this.stepVisuals(step)[value]; if (auto) return auto; }
    else if (!this.catalogFailed) return null; // Bild folgt, sobald das Sortiment geladen ist
    if (conf && conf.src && !(GAME_STEPS[step] && this.gameKey())) return conf;
    return null;
  };
  /* Alle Bilder eines Schritts gemeinsam wählen, damit keine zwei Antworten dasselbe Produkt zeigen */
  Finder.prototype.stepVisuals = function (step) {
    var game = this.gameKey(), key = step + ':' + (GAME_STEPS[step] ? game || '' : '');
    if (this.visualCache[key]) return this.visualCache[key];
    var self = this, out = {}, used = {};
    this.options(step).forEach(function (o) {
      var want = visualWant(step, String(o[0]), game);
      var p = want && self.pickVisual(want, used);
      if (!p) return;
      used[p.id] = 1;
      out[o[0]] = { src: p.image, alt: '', auto: true, id: p.id };
    });
    Object.keys(used).forEach(function (id) { self.shownVisuals[id] = 1; });
    this.visualCache[key] = out;
    return out;
  };
  Finder.prototype.pickVisual = function (want, used) {
    var fams = E.CONFIG.families, best = null, bestRank = Infinity;
    // Durchgang 1: gewünschte Produktarten. Durchgang 2 (nur mit Spiel): irgendein Sealed- oder Spielprodukt dieses Spiels.
    for (var pass = 1; pass <= 2 && !best; pass++) {
      if (pass === 2 && (!want.games || want.neutral)) break;
      for (var i = 0; i < this.rows.length; i++) {
        var p = E.prepare(this.rows[i]);
        if (!p.image || !p.family || used[p.id]) continue;
        var fi = pass === 1 ? want.fam.indexOf(p.family) : (/^(sealed|play)$/.test(fams[p.family] && fams[p.family].group) ? 0 : -1);
        if (fi < 0) continue;
        // Spielbezug nur über die Marke – Zubehör mit Spielnamen im Titel (z. B. Sortierboxen) zählt nicht
        if (want.games && (p.gameSource !== 'brand' || !p.games.some(function (g) { return want.games.indexOf(g) >= 0; }))) continue;
        if (want.neutral && p.games.length) continue;
        if (p.tags.indexOf('gift-exclude') >= 0 || E.presaleState(p, this.cfg.today)) continue;
        if (!p.variants.some(function (v) { return v.stock === 'in' && E.stockState(p, v).ok; })) continue;
        var rank = fi * 10 + (want.own && !p.isOwnBrand ? 5 : 0) + (want.premium && !/premium|leather|leder|zip/i.test(p.title) ? 3 : 0) +
          (p.language && p.language !== 'de' ? 3 : 0) + (this.shownVisuals[p.id] ? 8 : 0) + jitter(p.id, this.seed) * 4;
        if (rank < bestRank) { bestRank = rank; best = p; }
      }
    }
    return best;
  };
  Finder.prototype.refreshVisuals = function () {
    var self = this;
    this.stage.querySelectorAll('[data-ccgf-visual-for]').forEach(function (holder) {
      if (holder.querySelector('img')) return;
      var parts = holder.getAttribute('data-ccgf-visual-for').split(':');
      var vis = self.visualFor(parts[0], parts[1]);
      if (vis) { holder.appendChild(self.img(vis.src, '', vis.srcset, 210)); if (vis.logo) holder.classList.add('ccgf__option-media--logo'); }
    });
  };
  Finder.prototype.img = function (src, alt, srcset, w) {
    var url = safeUrl(src); var img = el('img');
    if (!url) return el('span', 'ccgf__noimg', '');
    img.src = url; if (srcset) img.srcset = srcset; img.sizes = '(min-width: 750px) 200px, 40vw';
    img.alt = alt || ''; img.loading = 'lazy'; img.decoding = 'async'; img.width = w || 400; img.height = w || 400;
    img.addEventListener('error', function () { var ph = el('span', 'ccgf__noimg', 'Bild nicht verfügbar'); img.replaceWith(ph); }, { once: true });
    return img;
  };

  /* ------------------------- Fragen ------------------------- */
  Finder.prototype.flow = function () { return E.steps(this.a); };
  /* Erwartete Gesamtzahl für die Fortschrittsanzeige: noch offene Verzweigungen werden mitgezählt */
  Finder.prototype.expected = function () {
    var f = this.flow().length, a = this.a;
    if (!a.game) f += 1; // Sprache
    if (!a.activity) f += 1; // Vertiefung
    return f;
  };
  Finder.prototype.options = function (key) {
    var self = this;
    if (key === 'otherGame') {
      var cfg = E.CONFIG.games, list = [];
      Object.keys(cfg).forEach(function (g) {
        if (cfg[g].main) return;
        var count = null;
        if (self.rows) { count = self.rows.filter(function (r) { var p = E.prepare(r); return p.games.indexOf(g) >= 0 && p.family; }).length; if (!count) return; }
        list.push([g, cfg[g].label, '']);
      });
      list.push(['unknown', 'Ich kenne den Namen nicht', 'Dann zeigen wir Geschenke, die zu jeder Sammlung passen.']);
      return list;
    }
    var opts = O[key] || [];
    var only = E.stepOptions(key, this.a);
    if (only) {
      opts = opts.filter(function (o) { return only.indexOf(o[0]) >= 0; });
      if (key === 'activity') opts = opts.map(function (o) { return o[0] === 'protect' ? ['protect', 'Sie besitzt schon Karten und bewahrt sie auf', 'Dann passen Sammelalben und Aufbewahrung.'] : ['unknown', 'Ich weiß es nicht', 'Dann ist ein Gutschein oft die sicherste Wahl.']; });
    }
    if (key === 'collectStyle' && this.a.knowledge === 'none') opts = opts.filter(function (o) { return o[0] !== 'set'; });
    return opts;
  };
  Finder.prototype.questionTitle = function (key) {
    var q = Q[key];
    if (key === 'activity' && E.stepOptions('activity', this.a)) return { title: 'Besitzt die Person schon Sammelkarten?', hint: 'Ohne bekanntes Kartenspiel bleiben wir bei Geschenken, die zu jeder Sammlung passen.' };
    if (key === 'knowledge' || this.a.knowledge !== 'expert') return q;
    return { title: q.title, hint: '' };
  };
  Finder.prototype.go = function (key, push) {
    if (push !== false) { try { W.history.pushState({ ccgf: this.uid, step: key }, ''); } catch (e) {} }
  };

  Finder.prototype.view = function (key, focus, fromHistory) {
    var self = this; this.seq++;
    var flow = this.flow(); var idx = flow.indexOf(key); if (idx < 0) { key = flow[0]; idx = 0; }
    if (!fromHistory) this.go(key);
    this.current = key;
    this.root.classList.remove('ccgf--results');
    this.stage.replaceChildren();
    var q = this.questionTitle(key);
    var pane = el('div', 'ccgf__pane');
    var head = el('div', 'ccgf__progress');
    var count = el('p', 'ccgf__count', 'Frage ' + (idx + 1) + ' von ' + this.expected());
    var bar = el('div', 'ccgf__bar'); bar.setAttribute('role', 'progressbar'); bar.setAttribute('aria-label', 'Fortschritt');
    bar.setAttribute('aria-valuemin', '1'); bar.setAttribute('aria-valuemax', String(this.expected())); bar.setAttribute('aria-valuenow', String(idx + 1));
    var fill = el('span'); fill.style.width = ((idx + 1) / this.expected() * 100).toFixed(1) + '%'; bar.appendChild(fill);
    head.append(count, bar); pane.appendChild(head);

    var form = el('form', 'ccgf__form'); form.noValidate = true;
    var fs = el('fieldset', 'ccgf__fieldset');
    var legend = el('legend', 'ccgf__question', q.title); legend.tabIndex = -1; fs.appendChild(legend);
    if (q.hint) { var hint = el('p', 'ccgf__hint', q.hint); hint.id = this.uid + '-hint'; fs.setAttribute('aria-describedby', hint.id); fs.appendChild(hint); }
    var grid = el('div', 'ccgf__options' + (FULL_STEPS[key] ? ' ccgf__options--rows' : '') + (IMAGE_STEPS[key] ? ' ccgf__options--visual' : ''));
    var err = el('p', 'ccgf__error'); err.setAttribute('role', 'alert'); err.hidden = true;
    var extra = el('div', 'ccgf__extra');
    var current = key === 'budget' ? this.a.budgetChoice : this.a[key];
    var name = this.uid + '-' + key;
    var next;
    this.options(key).forEach(function (o) {
      var val = String(o[0]);
      var label = el('label', 'ccgf__option');
      var input = el('input'); input.type = 'radio'; input.name = name; input.value = val; input.className = 'ccgf__radio';
      input.checked = String(current) === val;
      var body = el('span', 'ccgf__option-body');
      if (IMAGE_STEPS[key] && !(key === 'game' && val === 'unknown') && val !== 'unknown' && val !== 'open') {
        var holder = el('span', 'ccgf__option-media'); holder.setAttribute('data-ccgf-visual-for', key + ':' + val);
        var vis = self.visualFor(key, val);
        if (vis) { holder.appendChild(self.img(vis.src, '', vis.srcset, 210)); if (vis.logo) holder.classList.add('ccgf__option-media--logo'); }
        body.appendChild(holder);
      }
      var words = el('span', 'ccgf__option-words');
      words.appendChild(el('span', 'ccgf__option-label', o[1]));
      if (o[2]) words.appendChild(el('span', 'ccgf__option-help', o[2]));
      body.appendChild(words);
      body.appendChild(el('span', 'ccgf__check'));
      label.append(input, body);
      input.addEventListener('change', function () { self.choose(key, o[0], extra); err.hidden = true; update(); });
      grid.appendChild(label);
    });
    fs.append(grid, extra, err);
    form.appendChild(fs);
    this.extraFields(key, extra);

    var nav = el('div', 'ccgf__nav');
    var back = el('button', 'ccgf__btn ccgf__btn--ghost', 'Zurück'); back.type = 'button';
    back.addEventListener('click', function () { var f = self.flow(); var i = f.indexOf(key); if (i > 0) self.view(f[i - 1]); else self.restart(true); });
    var isLast = idx === flow.length - 1;
    next = el('button', 'ccgf__btn ccgf__btn--primary', isLast ? 'Geschenke anzeigen' : 'Weiter'); next.type = 'submit';
    nav.append(back, next); form.appendChild(nav);
    function update() {
      var ok = key === 'budget' ? !!self.a.budget : self.a[key] !== null && self.a[key] !== undefined;
      next.disabled = !ok;
      var f = self.flow(); next.textContent = f.indexOf(key) === f.length - 1 ? 'Geschenke anzeigen' : 'Weiter';
      var tot = self.expected();
      count.textContent = 'Frage ' + (f.indexOf(key) + 1) + ' von ' + tot;
      bar.setAttribute('aria-valuemax', String(tot)); fill.style.width = ((f.indexOf(key) + 1) / tot * 100).toFixed(1) + '%';
    }
    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var problem = self.validate(key, extra);
      if (problem) { err.textContent = problem.text; err.hidden = false; if (problem.focus) problem.focus.focus(); return; }
      self.track('giftfinder_question_answered', { step: key, answer: key === 'budget' ? self.budgetBucket() : String(self.a[key]) });
      var f = self.flow(); var i = f.indexOf(key);
      if (i >= f.length - 1) self.results(); else self.view(f[i + 1]);
    });
    pane.appendChild(form);
    this.stage.appendChild(pane);
    update();
    this.say('Frage ' + (idx + 1) + ' von ' + this.expected() + ': ' + q.title);
    if (focus !== false) this.focusTop(legend);
  };

  Finder.prototype.focusTop = function (target) {
    try { target.focus({ preventScroll: true }); } catch (e) { target.focus(); }
    var r = this.root.getBoundingClientRect();
    if (r.top < 0 || r.top > W.innerHeight * 0.5) this.root.scrollIntoView({ block: 'start', behavior: reduced() ? 'auto' : 'smooth' });
  };

  Finder.prototype.choose = function (key, value, extra) {
    var a = this.a;
    if (key === 'budget') {
      a.budgetChoice = String(value);
      if (value === 'custom') { var inp = extra.querySelector('input'); a.budget = parseMoney(inp && inp.value); }
      else a.budget = value === 'over300' ? 'over300' : Number(value);
      this.extraFields(key, extra);
      return;
    }
    a[key] = value;
    if (key === 'game') a.otherGame = null;
    if (key === 'game' || key === 'otherGame' || key === 'activity') {
      DEPTH_KEYS.forEach(function (k) { a[k] = null; }); a.favoriteTerm = ''; a.setTerm = '';
      if (key !== 'activity') a.activity = null;
    }
    this.extraFields(key, extra);
  };

  Finder.prototype.extraFields = function (key, box) {
    var self = this, a = this.a;
    box.replaceChildren();
    function field(id, labelText, value, placeholder, onInput, list) {
      var wrap = el('div', 'ccgf__field');
      var lab = el('label', 'ccgf__field-label', labelText); lab.htmlFor = self.uid + '-' + id;
      var inp = el('input', 'ccgf__input'); inp.id = self.uid + '-' + id; inp.type = 'text'; inp.value = value || ''; inp.placeholder = placeholder || ''; inp.autocomplete = 'off';
      inp.maxLength = 80;
      if (list && list.length) {
        var dl = el('datalist'); dl.id = inp.id + '-list';
        list.slice(0, 400).forEach(function (s) { var o = el('option'); o.value = s; dl.appendChild(o); });
        inp.setAttribute('list', dl.id); wrap.appendChild(dl);
      }
      inp.addEventListener('input', function () { onInput(inp.value); });
      wrap.append(lab, inp); box.appendChild(wrap);
      return inp;
    }
    var gameKey = a.game === 'other' ? a.otherGame : a.game;
    var sets = this.rows && gameKey && gameKey !== 'unknown' ? E.setNames(this.rows, gameKey) : [];
    if ((key === 'collectStyle' && a.collectStyle === 'set') || (key === 'rareKnowledge' && a.rareKnowledge === 'set')) {
      field('set', 'Name des Sets oder der Erweiterung', a.setTerm, sets.length ? 'z. B. ' + sets[Math.min(3, sets.length - 1)] : 'z. B. Prismatische Entwicklungen', function (v) { a.setTerm = v.trim(); }, sets);
    }
    if (key === 'rareKnowledge' && a.rareKnowledge === 'known') {
      field('fav', 'Name des Charakters oder der Karte', a.favoriteTerm, 'z. B. Glurak, Pikachu, Ruffy', function (v) { a.favoriteTerm = v.trim(); });
    }
    if (key === 'budget' && a.budgetChoice === 'custom') {
      var inp = field('amount', 'Dein Höchstbetrag in Euro', a.budget && a.budgetChoice === 'custom' ? (a.budget / 100).toFixed(2).replace('.', ',') : '', 'z. B. 60', function (v) {
        a.budget = parseMoney(v);
        var btn = self.stage.querySelector('.ccgf__nav .ccgf__btn--primary'); if (btn) btn.disabled = !a.budget;
      });
      inp.inputMode = 'decimal';
    }
    if (key === 'language') {
      var note = el('p', 'ccgf__note', 'Japanische, chinesische oder koreanische Karten sind in der jeweiligen Sprache bedruckt.');
      if (this.a.knowledge !== 'expert') box.appendChild(note);
    }
  };
  Finder.prototype.validate = function (key, box) {
    var a = this.a;
    if (key === 'budget' && a.budgetChoice === 'custom' && !a.budget) return { text: 'Bitte gib einen Betrag über 0 € ein, zum Beispiel 60.', focus: box.querySelector('input') };
    if ((a.collectStyle === 'set' && key === 'collectStyle') || (a.rareKnowledge === 'set' && key === 'rareKnowledge')) {
      if (!a.setTerm || a.setTerm.length < 3) return { text: 'Bitte gib mindestens drei Buchstaben des Set-Namens ein.', focus: box.querySelector('input') };
    }
    if (key === 'rareKnowledge' && a.rareKnowledge === 'known' && (!a.favoriteTerm || a.favoriteTerm.length < 2)) return { text: 'Bitte gib den Namen des Charakters oder der Karte ein.', focus: box.querySelector('input') };
    return null;
  };
  Finder.prototype.budgetBucket = function () {
    var b = this.a.budget; if (b === 'over300') return 'over300';
    if (!b) return 'none'; var lims = [2000, 4000, 7500, 15000, 30000];
    for (var i = 0; i < lims.length; i++) if (b <= lims[i]) return 'to' + lims[i] / 100;
    return 'over300';
  };

  Finder.prototype.summary = function () {
    var self = this, box = el('div', 'ccgf__summary');
    var list = el('ul', 'ccgf__chips');
    this.flow().forEach(function (k) {
      if (k === 'knowledge') return;
      var label;
      if (k === 'budget') label = self.a.budget === 'over300' ? 'Mehr als 300 €' : 'Bis ' + self.money.format(self.a.budget / 100);
      else {
        var o = self.options(k).filter(function (x) { return String(x[0]) === String(self.a[k]); })[0];
        label = o ? o[1] : '';
        if (k === 'rareKnowledge' && self.a.favoriteTerm && self.a.rareKnowledge === 'known') label = 'Motiv: ' + self.a.favoriteTerm;
        if ((k === 'collectStyle' && self.a.collectStyle === 'set') || (k === 'rareKnowledge' && self.a.rareKnowledge === 'set')) label = 'Set: ' + self.a.setTerm;
      }
      if (!label) return;
      var li = el('li'); var b = el('button', 'ccgf__chip', label); b.type = 'button'; b.setAttribute('aria-label', label + ' – Antwort ändern');
      b.addEventListener('click', function () { self.view(k); }); li.appendChild(b); list.appendChild(li);
    });
    var edit = el('button', 'ccgf__btn ccgf__btn--ghost ccgf__edit', 'Antworten ändern'); edit.type = 'button';
    edit.addEventListener('click', function () { self.view(self.flow()[0]); });
    box.append(list, edit);
    return box;
  };

  /* ------------------------- Ergebnisse ------------------------- */
  Finder.prototype.results = function (fromHistory) {
    var self = this, seq = ++this.seq;
    if (!fromHistory) this.go('_results');
    this.root.classList.add('ccgf--results');
    this.stage.replaceChildren();
    var top = el('div', 'ccgf__results-head');
    var h = el('h2', 'ccgf__results-title', 'Diese Geschenke passen zu deiner Auswahl.'); h.tabIndex = -1;
    top.append(h, el('p', 'ccgf__results-sub', 'Wir haben passende Geschenkideen aus unserem Sortiment für dich zusammengestellt.'), this.summary());
    var zone = el('div', 'ccgf__zone'); zone.setAttribute('aria-busy', 'true');
    var wait = el('div', 'ccgf__loading');
    wait.append(el('span', 'ccgf__spinner'), el('p', 'ccgf__loading-text', 'Wir prüfen das Sortiment …'));
    var prog = el('p', 'ccgf__loading-progress'); prog.setAttribute('data-ccgf-progress', ''); wait.appendChild(prog);
    if (this.progress) prog.textContent = this.progress[0].toLocaleString('de-DE') + ' von ' + this.progress[1].toLocaleString('de-DE') + ' Produkten geprüft';
    zone.appendChild(wait);
    this.stage.append(top, zone);
    this.focusTop(h);
    this.say('Passende Geschenke werden gesucht.');
    this.catalog().then(function (rows) {
      if (seq !== self.seq || self.dead) return;
      var answers = Object.assign({}, self.a, { today: self.cfg.today });
      var rec = E.recommend(rows, answers, { today: self.cfg.today });
      return self.verify(rec).then(function (final) {
        if (seq !== self.seq || self.dead) return;
        self.render(zone, final, rows, answers);
      });
    }).catch(function (e) {
      if (seq !== self.seq || self.dead) return;
      console.warn('[Geschenkefinder]', e);
      zone.replaceChildren(); zone.removeAttribute('aria-busy');
      var box = el('div', 'ccgf__empty');
      box.append(el('h3', 'ccgf__empty-title', 'Das Sortiment konnte gerade nicht vollständig geladen werden.'),
        el('p', '', 'Damit wir nichts Unpassendes empfehlen, zeigen wir in diesem Fall keine Auswahl. Deine Antworten bleiben gespeichert.'));
      var retry = el('button', 'ccgf__btn ccgf__btn--primary', 'Erneut versuchen'); retry.type = 'button';
      retry.addEventListener('click', function () { self.rows = null; try { W.sessionStorage.removeItem(self.cacheKey()); } catch (x) {} self.results(); });
      var all = el('a', 'ccgf__btn ccgf__btn--ghost', 'Alle Produkte ansehen'); all.href = self.cfg.allProductsUrl || '/collections/all';
      var acts = el('div', 'ccgf__actions'); acts.append(retry, all); box.appendChild(acts);
      zone.appendChild(box); self.say('Das Sortiment konnte nicht geladen werden.');
    });
  };

  /* Live-Prüfung eines Produkts über die Ajax-API (je Ergebnisseite zwischengespeichert).
     Liefert true, wenn bestellbar und im Budget; aktualisiert dabei einen geänderten Preis. */
  Finder.prototype.confirm = function (item, prof) {
    var cache = this.liveCache || (this.liveCache = {}), key = item.p.handle + ':' + item.v.id;
    var root = (W.Shopify && W.Shopify.routes && W.Shopify.routes.root) || '/';
    if (!cache[key]) cache[key] = this.request(root + 'products/' + encodeURIComponent(item.p.handle) + '.js', 'json').then(function (live) {
      var v = (live.variants || []).filter(function (x) { return String(x.id) === String(item.v.id); })[0];
      return v && v.available && typeof v.price === 'number' && v.price > 0 ? v.price : null;
    }).catch(function () { return null; });
    return cache[key].then(function (price) {
      if (price === null || (prof.budget && !prof.budget.open && price > prof.budget.max)) return false;
      if (price !== item.v.price) item.v = Object.assign({}, item.v, { price: price });
      return true;
    });
  };
  /* Kritischer Pfad: nur Hauptempfehlung, Alternativen und Ergänzungen – alle parallel.
     „Weitere Geschenke“ werden erst nach dem Anzeigen im Hintergrund geprüft. */
  Finder.prototype.verify = function (rec) {
    var self = this, prof = rec.evaluation.profile, bad = {}, rounds = 0;
    this.liveCache = {};
    if (this.cfg.preview || !rec.selection.main) return Promise.resolve(rec);
    function check(item) { return self.confirm(item, prof); }
    function shown(sel) { return [sel.main].concat(sel.alternatives.map(function (x) { return x.item; })).filter(Boolean); }
    pool(rec.related, 6, check); // startet parallel, Ergebnis kommt unten aus dem Zwischenspeicher
    function round() {
      rounds++;
      var list = shown(rec.selection);
      return pool(list, 6, check).then(function (res) {
        var failed = list.filter(function (x, i) { return !res[i]; });
        failed.forEach(function (f) { bad[f.p.id] = 1; });
        if (!failed.length || rounds > 3) { rec.selection = filterSel(rec.selection, bad); return rec; }
        rec.selection = E.select(rec.evaluation.items.filter(function (x) { return !bad[x.p.id]; }), prof);
        var remaining = prof.budget && !prof.budget.open && rec.selection.main ? prof.budget.max - rec.selection.main.v.price : Infinity;
        rec.related = E.related(rec.selection.main, rec.evaluation, remaining);
        return round();
      });
    }
    function filterSel(sel, b) {
      return { main: sel.main && !b[sel.main.p.id] ? sel.main : null, alternatives: sel.alternatives.filter(function (x) { return !b[x.item.p.id]; }), more: sel.more.filter(function (x) { return !b[x.p.id]; }) };
    }
    return round().then(function (r) {
      if (!r.selection.main && r.selection.alternatives.length) { r.selection.main = r.selection.alternatives.shift().item; }
      return pool(r.related, 6, check).then(function (res) {
        r.related = r.related.filter(function (x, i) { return res[i]; });
        r.liveChecked = Object.keys(self.liveCache).length;
        return r;
      });
    });
  };
  function pool(list, n, fn) {
    var out = new Array(list.length), i = 0;
    function worker() { if (i >= list.length) return Promise.resolve(); var k = i++; return Promise.resolve(fn(list[k])).then(function (r) { out[k] = r; return worker(); }); }
    var ws = []; for (var w = 0; w < Math.min(n, list.length); w++) ws.push(worker());
    return Promise.all(ws).then(function () { return out; });
  }

  Finder.prototype.render = function (zone, rec, rows, answers) {
    var self = this, sel = rec.selection, prof = rec.evaluation.profile;
    var uniq = E.uniqueAcross(sel, rec.related, 4);
    rec.related = uniq.related; sel.more = uniq.more;
    zone.replaceChildren(); zone.removeAttribute('aria-busy');
    if (!sel.main) { var ht = this.stage.querySelector('.ccgf__results-title'); if (ht) ht.textContent = 'Deine Auswahl'; var hs = this.stage.querySelector('.ccgf__results-sub'); if (hs) hs.textContent = 'Du kannst jede Antwort antippen und ändern.'; this.renderEmpty(zone, rows, answers, prof); return; }
    var main = this.card(sel.main, prof, null, true);
    zone.appendChild(main);
    if (sel.alternatives.length) {
      zone.appendChild(el('h3', 'ccgf__section-title', 'Weitere Ideen'));
      var alts = el('div', 'ccgf__alts');
      sel.alternatives.forEach(function (a) { alts.appendChild(self.card(a.item, prof, a.role, false, sel.main)); });
      zone.appendChild(alts);
    }
    var relatedShown = (rec.related || []).slice(0, 4);
    if (relatedShown.length) {
      var rel = el('aside', 'ccgf__related');
      rel.appendChild(el('h3', 'ccgf__section-title', 'Passt gut dazu'));
      rel.appendChild(el('p', 'ccgf__section-sub', 'Ergänzungen zur Empfehlung, die noch ins Budget passen.'));
      var ul = el('ul', 'ccgf__tiles');
      relatedShown.forEach(function (r) {
        var li = el('li', 'ccgf__tile');
        var a = el('a', 'ccgf__tile-link'); var href = safeUrl(r.p.url, !self.cfg.preview); if (href) a.href = href;
        var media = el('span', 'ccgf__tile-media'); if (r.p.image) media.appendChild(self.img(r.p.image, '', null, 320)); else media.appendChild(el('span', 'ccgf__noimg', ''));
        var t = el('span', 'ccgf__tile-name', r.p.title); var pr = el('span', 'ccgf__tile-price', self.money.format(r.v.price / 100));
        a.append(media, t, pr); li.appendChild(a); ul.appendChild(li);
        a.addEventListener('click', function () { self.track('giftfinder_product_clicked', { slot: 'related', family: r.family }); });
      });
      rel.appendChild(ul); zone.appendChild(rel);
    }
    if (sel.more.length) {
      var moreBtn = el('button', 'ccgf__btn ccgf__btn--ghost ccgf__more', 'Weitere passende Geschenke ansehen'); moreBtn.type = 'button';
      moreBtn.setAttribute('aria-expanded', 'false');
      // Im Hintergrund vorprüfen, damit das Aufklappen sofort geht
      var moreChecked = null, seqNow = this.seq;
      var checkMore = function () {
        if (!moreChecked) moreChecked = self.cfg.preview ? Promise.resolve(sel.more) :
          pool(sel.more, 3, function (m) { return self.confirm(m, prof); }).then(function (res) { return sel.more.filter(function (x, i) { return res[i]; }); });
        return moreChecked;
      };
      setTimeout(function () { if (self.seq === seqNow) checkMore(); }, 800);
      moreBtn.addEventListener('click', function () {
        moreBtn.disabled = true; moreBtn.textContent = 'Einen Moment …';
        checkMore().then(function (list) {
          if (self.seq !== seqNow) return;
          if (!list.length) { moreBtn.remove(); self.say('Gerade gibt es keine weiteren passenden Geschenke.'); return; }
          var grid = el('section', 'ccgf__more-grid'); grid.tabIndex = -1;
          grid.appendChild(el('h3', 'ccgf__section-title', 'Weitere passende Geschenke'));
          var tiles = el('ul', 'ccgf__tiles ccgf__tiles--more');
          list.forEach(function (m) { tiles.appendChild(self.tile(m, 'more')); });
          grid.appendChild(tiles);
          moreBtn.replaceWith(grid); grid.focus({ preventScroll: true });
          self.say(list.length + ' weitere Geschenkideen eingeblendet.');
        });
      });
      zone.appendChild(moreBtn);
    }
    var foot = el('div', 'ccgf__footer');
    foot.appendChild(el('p', 'ccgf__verified', this.cfg.preview ? 'Vorschau: Verfügbarkeit simuliert' : 'Preise und Verfügbarkeit live geprüft'));
    var restart = el('button', 'ccgf__btn ccgf__btn--ghost ccgf__restart', 'Neue Suche starten'); restart.type = 'button';
    restart.addEventListener('click', function () { self.restart(); });
    foot.appendChild(restart);
    zone.appendChild(foot);
    if (this.debug) zone.appendChild(this.diagnostics(rec));
    var shownCount = 1 + sel.alternatives.length;
    this.say(shownCount + ' Geschenkideen gefunden.');
    this.track('giftfinder_completed', { game: prof.game, activity: prof.activity, depth: prof.depth, language: prof.language, budget: this.budgetBucket(), knowledge: prof.knowledge });
    this.track('giftfinder_results_viewed', { main: sel.main.family, alternatives: sel.alternatives.map(function (x) { return x.item.family; }).join(','), eligible: rec.evaluation.items.length });
  };

  Finder.prototype.card = function (item, prof, role, isMain, mainItem) {
    var self = this, p = item.p, v = item.v;
    var ex = E.explain(item, prof, role === 'more' ? null : role);
    var art = el('article', 'ccgf__card' + (isMain ? ' ccgf__card--main' : role === 'more' ? ' ccgf__card--compact' : ''));
    var media = el('div', 'ccgf__card-media');
    var imgSrc = v.image || p.image;
    if (imgSrc) media.appendChild(this.img(imgSrc, p.imageAlt || p.title, null, isMain ? 640 : 400)); else media.appendChild(el('span', 'ccgf__noimg', 'Kein Produktbild hinterlegt'));
    if (isMain) { var mb = el('span', 'ccgf__badge ccgf__badge--media', 'Unsere Empfehlung'); mb.setAttribute('aria-hidden', 'true'); media.appendChild(mb); }
    var body = el('div', 'ccgf__card-body');
    var tag = el('p', isMain ? 'ccgf__badge' : 'ccgf__role', isMain ? 'Unsere Empfehlung' : ex.roleLabel);
    body.appendChild(tag);
    var title = el(isMain ? 'h3' : 'h4', 'ccgf__card-title', p.title); body.appendChild(title);
    var metaLine = el('p', 'ccgf__card-meta');
    metaLine.appendChild(el('span', 'ccgf__price', this.money.format(v.price / 100)));
    if (v.title && v.title !== 'Default Title' && p.family !== 'gift') metaLine.appendChild(el('span', 'ccgf__variant', 'Ausführung: ' + v.title));
    metaLine.appendChild(el('span', 'ccgf__family', ex.familyLabel));
    body.appendChild(metaLine);
    if (role !== 'more') {
      if (mainItem && role) { var cmp = E.compareToMain(item, mainItem); if (cmp) body.appendChild(el('p', 'ccgf__compare', cmp)); }
      if (ex.text) body.appendChild(el('p', 'ccgf__reason', ex.text));
      if (ex.glossary && isMain) { var gl = el('p', 'ccgf__glossary'); gl.append(el('strong', '', 'Kurz erklärt: '), D.createTextNode(ex.glossary)); body.appendChild(gl); }
      if (ex.facts.length && isMain) {
        var dl = el('dl', 'ccgf__facts');
        ex.facts.forEach(function (f) { var row = el('div', 'ccgf__fact'); row.append(el('dt', '', f[0]), el('dd', '', f[1])); dl.appendChild(row); });
        body.appendChild(dl);
      }
      if (ex.hints.length) { var ul = el('ul', 'ccgf__hints'); ex.hints.forEach(function (h) { ul.appendChild(el('li', '', h)); }); body.appendChild(ul); }
    }
    var link = el('a', 'ccgf__btn ' + (isMain ? 'ccgf__btn--primary' : 'ccgf__btn--outline') + ' ccgf__cta', 'Produkt ansehen');
    var href = safeUrl(p.url, !this.cfg.preview);
    if (href) { var u = new URL(href); if (p.variants.length > 1) u.searchParams.set('variant', String(v.id)); link.href = u.href; if (this.cfg.preview) { link.target = '_blank'; link.rel = 'noopener'; } }
    link.setAttribute('aria-label', 'Produkt ansehen: ' + p.title);
    link.addEventListener('click', function () { self.track('giftfinder_product_clicked', { slot: isMain ? 'main' : role, family: item.family }); });
    body.appendChild(link);
    art.append(media, body);
    return art;
  };
  /* Einheitliche Produktkachel: 1:1-Bild, Name (max. zwei Zeilen), Preis */
  Finder.prototype.tile = function (item, slot) {
    var self = this, p = item.p, v = item.v;
    var li = el('li', 'ccgf__tile');
    var a = el('a', 'ccgf__tile-link'); var href = safeUrl(p.url, !this.cfg.preview);
    if (href) { var u = new URL(href); if (p.variants.length > 1) u.searchParams.set('variant', String(v.id)); a.href = u.href; }
    var media = el('span', 'ccgf__tile-media'); var src = v.image || p.image;
    media.appendChild(src ? this.img(src, '', null, 320) : el('span', 'ccgf__noimg', ''));
    var fam = E.CONFIG.families[p.family];
    a.append(media, el('span', 'ccgf__tile-kicker', fam ? fam.label : ''), el('span', 'ccgf__tile-name', p.title), el('span', 'ccgf__tile-price', this.money.format(v.price / 100)));
    a.addEventListener('click', function () { self.track('giftfinder_product_clicked', { slot: slot, family: item.family }); });
    li.appendChild(a);
    return li;
  };

  Finder.prototype.renderEmpty = function (zone, rows, answers, prof) {
    var self = this;
    this.track('giftfinder_no_results', { game: prof.game, activity: prof.activity, depth: prof.depth, language: prof.language, budget: this.budgetBucket() });
    var box = el('div', 'ccgf__empty');
    box.appendChild(el('h3', 'ccgf__empty-title', 'Für diese Auswahl haben wir gerade kein passendes Geschenk gefunden.'));
    box.appendChild(el('p', '', 'Wir zeigen lieber nichts als etwas Unpassendes. Mit einer kleinen Änderung klappt es oft:'));
    var sug = E.suggestions(rows, answers, { today: this.cfg.today });
    var list = el('ul', 'ccgf__suggest');
    function action(label, help, fn, primary) {
      var li = el('li', 'ccgf__suggest-item');
      var b = el('button', 'ccgf__btn ' + (primary ? 'ccgf__btn--primary' : 'ccgf__btn--outline'), label); b.type = 'button'; b.addEventListener('click', fn);
      li.appendChild(b); if (help) li.appendChild(el('p', 'ccgf__suggest-help', help)); list.appendChild(li);
    }
    var bud = sug.filter(function (s) { return s.type === 'budget'; })[0];
    action('Budget ändern', bud ? bud.label : '', function () { self.view('budget'); }, true);
    var lang = sug.filter(function (s) { return s.type === 'language'; })[0];
    if (this.flow().indexOf('language') >= 0) action('Sprache ändern', lang ? lang.label : '', function () { self.view('language'); });
    var dk = DEPTH_KEYS.filter(function (k) { return self.flow().indexOf(k) >= 0; })[0];
    var dep = sug.filter(function (s) { return s.type === 'depth'; })[0];
    if (dk) action('Geschenkart ändern', dep ? dep.label : '', function () { self.view(dk); });
    action('Antworten bearbeiten', '', function () { self.view(self.flow()[0]); });
    var gift = E.giftCardOptions(rows, prof);
    if (gift) {
      action('Geschenkgutschein ansehen', 'Mit einem Gutschein ab ' + this.money.format(Math.min.apply(null, gift.p.variants.filter(function (v) { return v.available; }).map(function (v) { return v.price; })) / 100) + ' sucht sich die Person selbst etwas aus.', function () {
        var href = safeUrl(gift.p.url, !self.cfg.preview); if (href) W.location.href = href;
      });
    }
    box.appendChild(list); zone.appendChild(box);
    this.say('Keine passenden Produkte gefunden.');
  };

  Finder.prototype.diagnostics = function (rec) {
    var ev = rec.evaluation, d = el('details', 'ccgf__debug');
    d.appendChild(el('summary', '', 'Entwicklerdiagnose (nur im Theme-Editor sichtbar)'));
    var top = ev.items.slice(0, 20).map(function (x) { return { produkt: x.p.title, familie: x.family, preis: x.v.price, score: x.score, gruende: x.parts.map(function (p) { return p[0] + ' ' + p[1]; }), daten: E.explain(x, ev.profile).usedFields, klassifizierung: x.p.classification }; });
    var info = { laden: this.loadInfo, profil: ev.profile, metriken: ev.metrics, liveGeprueft: rec.liveChecked || 0, top20: top };
    d.appendChild(el('pre', '', JSON.stringify(info, null, 2)));
    return d;
  };

  Finder.prototype.restart = function (toIntro, keep) {
    if (!keep) { this.a = fresh(); this.track('giftfinder_restarted', {}); }
    if (toIntro && this.intro) { this.stage.replaceChildren(); this.intro.hidden = false; this.root.classList.remove('ccgf--running', 'ccgf--results'); var b = this.intro.querySelector('[data-ccgf-start]'); if (b) b.focus(); return; }
    this.view('knowledge');
  };
  Finder.prototype.destroy = function () {
    this.dead = true; this.seq++; this.controllers.forEach(function (c) { try { c.abort(); } catch (e) {} });
    if (this.unwarm) this.unwarm();
    W.removeEventListener('popstate', this.onPop);
  };

  var instances = typeof WeakMap === 'function' ? new WeakMap() : null;
  function scan(scope) {
    scope = scope || D;
    var roots = [];
    if (scope.matches && scope.matches('[data-ccgf]')) roots.push(scope);
    roots.push.apply(roots, scope.querySelectorAll ? scope.querySelectorAll('[data-ccgf]') : []);
    roots.forEach(function (r) {
      if (instances && instances.has(r)) return;
      try { var f = new Finder(r); if (instances) instances.set(r, f); if (W.location.hash === '#start' && !r.classList.contains('ccgf--running')) f.begin(); }
      catch (e) { console.warn('[Geschenkefinder] Start fehlgeschlagen', e); var st = r.querySelector('[data-ccgf-stage]'); if (st) st.textContent = 'Der Geschenkefinder kann gerade nicht geöffnet werden. Bitte nutze unsere Produktkategorien.'; }
    });
  }
  W.CCGiftFinder = { scan: scan, version: '4.0.0' };
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', function () { scan(D); }); else scan(D);
  D.addEventListener('shopify:section:load', function (e) { scan(e.target); });
  // Buttons außerhalb des Finders (z. B. im FAQ) starten ihn direkt
  D.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-ccgf-launch]'); if (!t) return;
    var r = D.querySelector('[data-ccgf]'), f = r && instances && instances.get(r); if (!f) return;
    e.preventDefault();
    if (r.classList.contains('ccgf--running')) r.scrollIntoView({ block: 'start', behavior: reduced() ? 'auto' : 'smooth' }); else f.begin();
  });
  D.addEventListener('shopify:section:unload', function (e) {
    (e.target.querySelectorAll ? e.target.querySelectorAll('[data-ccgf]') : []).forEach(function (r) { var f = instances && instances.get(r); if (f) { f.destroy(); instances.delete(r); } });
  });
})();
